import React from 'react';
import { Box, Grid2 } from '@mui/material';
import {
  CustomDialog,
  CustomDialogActions,
  CustomDialogContent,
  CustomTypography,
} from '@qler-view/shared_lib/src';
import CustomButton from '@qler-view/shared_lib/src/shared/lib/ui-components/Button/CustomButton';

export interface ActivateConsultConfirmationPopupProps {
  openPopup: boolean;
  onClosePopup: () => void;
  onConfirm: () => void;
}

const ActivateConsultConfirmationPopup: React.FC<
  ActivateConsultConfirmationPopupProps
> = ({ openPopup, onClosePopup, onConfirm }) => {
  return (
    <Box>
      <CustomDialog
        id="activate-consult-dialog"
        open={openPopup}
        onClose={(reason) => {
          if (reason === 'backdropClick') {
            return;
          }
          onClosePopup();
        }}
        disableEscapeKeyDown={true}
      >
        <CustomDialogContent className="dialog-width">
          <Box className="pb-6">
            <CustomTypography
              id="activate-consult-title-popup"
              variant="subtitle1"
            >
              Activate Consult
            </CustomTypography>
          </Box>
          <Box>
            <CustomTypography
              id="activate-consult-message-popup"
              variant="body3"
            >
              Are you sure you want to move this consult request to the NEW
              status?
            </CustomTypography>
          </Box>
        </CustomDialogContent>

        <CustomDialogActions>
          <Grid2 container>
            <Grid2 className="mr-8">
              <CustomButton
                id="btnCancel"
                color="primary"
                variant="outlined"
                onClick={() => {
                  onClosePopup();
                }}
              >
                Cancel
              </CustomButton>
            </Grid2>
            <Grid2>
              <CustomButton
                id="btnConfirm"
                color="primary"
                variant="contained"
                onClick={() => {
                  onConfirm();
                }}
              >
                Confirm
              </CustomButton>
            </Grid2>
          </Grid2>
        </CustomDialogActions>
      </CustomDialog>
    </Box>
  );
};

export default ActivateConsultConfirmationPopup;
